// extracted by mini-css-extract-plugin
export default {"info_block":"InfoBlock_info_block__ullF5","message":"InfoBlock_message__RfmEZ","title":"InfoBlock_title__3PLlm","icon":"InfoBlock_icon__eLChX","content":"InfoBlock_content__3nIGQ"};